import { FaTwitter, FaFacebookF, FaInstagram, FaGithub } from "react-icons/fa";

// -------------------------------------------- Navigation Menu Data Array --------------------------------------------
export const navMenu = [
  { url: "/", name: "Home" },
  { url: "/#services", name: "Services" },
  { url: "/#solutions", name: "Solutions" },
  { url: "/about", name: "About Us" },
  { url: "/projects", name: "Projects" },
  // { url: "/career", name: "Career" },
]

// -------------------------------------------- Footer Data Array --------------------------------------------
export const footerData = {
  companyName: "SM Electrifier",
  description: "Tempus congue tellus semper sapien urna. Tellus posuere ut.",
  socialLinks: [
    { icon: <FaTwitter />, link: "#" },
    { icon: <FaFacebookF />, link: "#" },
    { icon: <FaInstagram />, link: "#" },
    { icon: <FaGithub />, link: "#" },
  ],
  columns: [
    {
      title: "Company",
      links: ["About Us", "Our Services", "Careers", "Our Projects"],
    },
    {
      title: "Resources",
      links: ["Electrical Safety", "Blog", "Energy Efficiency", "Youtube Channel"],
    },
  ],
  subscribe: {
    title: "Subscribe",
    placeholder: "Your email",
    buttonText: "Subscribe",
  },
  footerBottom: {
    copyright: "© ",
    designer: { name: "one08.tech", link: "https://one08.tech" }, // ✅ Clickable Link
    links: ["Terms of Use", "Privacy Policy", "Cookie Policy"],
  },
};


//----------------------------------------Banner Info ----------------------------------------

export const bannerInfo = {
  title: (
    <>
      Quality Assured, Cost-effective, <br />
      Result Orientated Recruiting Solutions
    </>
  ),
  description:
    "Eclectic Allocation is a full-service search firm specializing in 3 main areas: Information Technology, Business and Marketing Functions, and Security.",
  buttonText: "BOOK AN APPOINTMENT",
  image:[
    "/images/herosection_pr.png",
    "/images/image3.jpeg",
    "/images/imge2.jpeg",
    "/images/imge4.jpeg"
  ]
};


// -------------------------------------------- About Data Array --------------------------------------------

export const aboutData = {
  title: "We provide best Electrical Solution in town.",
  subtitle: "WHO WE ARE?",
  description: [
      "At SM Electrifier, our mission is to help our customers create safe and efficient commercial, industrial, and residential infrastructure. We achieve this through our one-stop solution offering of",
      "Mechanical, Electrical, Plumbing, and Fire Safety installation services. Established in 2022 across India, we have grown from a well-recognized Super Grade Electrical Contractor in Karnataka to a full-fledged General Contracting Company offering MEPF services.",
  ],
  experience: {
      years: "6+",
      text: "YEAR OF EXPERIENCE",
  },
  button: {
      text: "More Info",
      link: "/about",
  },
  image: "/images/abt.png", // Update with your actual image path
};






// -------------------------------------------- Services Data Array --------------------------------------------

export const services = [
  {
      id: 1,
      title: "Engineering",
      description: "From residential households to commercial enterprises, we provide reliable, efficient, and sustainable energy solutions.",
      image: "https://img.freepik.com/free-photo/two-colleagues-factory_1303-14331.jpg?t=st=1741530653~exp=1741534253~hmac=46b7d531a1035a7bfd244c290663ed8e8fea80b96e2aceb5e41044063f8c4501&w=1380",
  },
  {
      id: 2,
      title: "HT & LT Works",
      description: "From residential households to commercial enterprises, we provide reliable, efficient, and sustainable energy solutions.",
      image: "https://img.freepik.com/free-photo/male-electrician-works-switchboard-with-electrical-connecting-cable_169016-15204.jpg?t=st=1741530699~exp=1741534299~hmac=4c02f94d2c629e8ef49612c8f8ae5b905d901fb18931ad41395273995af6f836&w=1380",
  },
  {
      id: 3,
      title: "Internal & External Electrification",
      description: "From residential households to commercial enterprises, we provide reliable, efficient, and sustainable energy solutions.",
      image: "https://img.freepik.com/free-photo/vintage-light-lamp_74190-4394.jpg?t=st=1741530724~exp=1741534324~hmac=da141a29047aea034a58fe00da2e2d4efa0010d8cd101162f45430370c67a3bc&w=1380",
  },
  {
      id: 4,
      title: "Industrial & Commercial",
      description: "From residential households to commercial enterprises, we provide reliable, efficient, and sustainable energy solutions.",
      image: "https://img.freepik.com/free-photo/factory-workshop-interior-machines-glass-production-background_645730-396.jpg?t=st=1741530720~exp=1741534320~hmac=9ac90bbe47f796ff36046a0a6cbe725a74b1f2523a58fa096afa41a03804a952&w=1380",
  },
  {
      id: 5,
      title: "Maintenance & Services",
      description: "From residential households to commercial enterprises, we provide reliable, efficient, and sustainable energy solutions.",
      image: "https://img.freepik.com/free-photo/man-electrical-technician-working-switchboard-with-fuses_169016-24062.jpg?t=st=1741530795~exp=1741534395~hmac=b50cbf3617febeea92d0c3d04c38eb32e1cd3da7dc58463a921cc973bc25b5a7&w=1380",
  },
];


// -------------------------------------------- why choose Data Array --------------------------------------------	

export const whyChooseData = {
  title: "Powering the Future of Electrical Solutions",
  subtitle: "WHY CHOOSE US",
  description: "We redefine what electrical services should be. Our mission is simple: deliver reliable, cutting-edge solutions that empower your life. With expert electricians, we focus on innovation and efficiency in every project.",
  features: [
      {
          icon: "/icons/1.png", // Replace with actual icon path
          title: "Expertise and Insight",
          description: "Skilled professionals for every task.",
      },
      {
          icon: "/icons/2.png",
          title: "Innovative Technology",
          description: "Skilled professionals for every task.",
      },
      {
          icon: "/icons/3.png",
          title: "Tailored Solutions",
          description: "Skilled professionals for every task.",
      },
      {
          icon: "/icons/4.png",
          title: "Collaborative Partnerships",
          description: "Skilled professionals for every task.",
      },
      {
          icon: "/icons/5.png",
          title: "Future-Focused Vision",
          description: "Skilled professionals for every task.",
      },
  ],
  images: {
      main: "/images/who.png", // Replace with actual image
      secondary: "https://img.freepik.com/free-photo/two-colleagues-factory_1303-14331.jpg?t=st=1741538684~exp=1741542284~hmac=93e3424f45bb4a9673ce698717e3504c70a21e8e440d0401e9ff6e799679c3c7&w=1380",
  },
};


// -------------------------------------------- Projects Data Array --------------------------------------------
export const projects = [
  {
    id: 1,
    title: "Smart Grid Installation",
    category: "Ongoing",
    description: "A cutting-edge smart grid installation for a modern office space.",
    thumbnail: "https://img.freepik.com/free-photo/engineer-meeting-architectural-project-working-with-partner_1421-70.jpg",
    images: [
      "https://img.freepik.com/free-photo/male-asian-engineer-professional-having-discussion-standing-by-machine-factory-two-asian-coworker-brainstorm-explaining-solves-process-curcuit-mother-board-machine_609648-898.jpg?uid=R57968291&ga=GA1.1.1137758464.1733557650&semt=ais_hybrid",
      "https://img.freepik.com/free-photo/male-asian-engineer-professional-having-discussion-standing-by-machine-factory-two-asian-coworker-brainstorm-explaining-solves-process-curcuit-mother-board-machine_609648-898.jpg?uid=R57968291&ga=GA1.1.1137758464.1733557650&semt=ais_hybrid",
      "https://img.freepik.com/free-photo/male-asian-engineer-professional-having-discussion-standing-by-machine-factory-two-asian-coworker-brainstorm-explaining-solves-process-curcuit-mother-board-machine_609648-898.jpg?uid=R57968291&ga=GA1.1.1137758464.1733557650&semt=ais_hybrid",
      "https://img.freepik.com/free-photo/male-asian-engineer-professional-having-discussion-standing-by-machine-factory-two-asian-coworker-brainstorm-explaining-solves-process-curcuit-mother-board-machine_609648-898.jpg?uid=R57968291&ga=GA1.1.1137758464.1733557650&semt=ais_hybrid",
      "https://img.freepik.com/free-photo/male-asian-engineer-professional-having-discussion-standing-by-machine-factory-two-asian-coworker-brainstorm-explaining-solves-process-curcuit-mother-board-machine_609648-898.jpg?uid=R57968291&ga=GA1.1.1137758464.1733557650&semt=ais_hybrid",
      "https://img.freepik.com/free-photo/male-asian-engineer-professional-having-discussion-standing-by-machine-factory-two-asian-coworker-brainstorm-explaining-solves-process-curcuit-mother-board-machine_609648-898.jpg?uid=R57968291&ga=GA1.1.1137758464.1733557650&semt=ais_hybrid",
      "https://img.freepik.com/free-photo/male-asian-engineer-professional-having-discussion-standing-by-machine-factory-two-asian-coworker-brainstorm-explaining-solves-process-curcuit-mother-board-machine_609648-898.jpg?uid=R57968291&ga=GA1.1.1137758464.1733557650&semt=ais_hybrid",
      "https://img.freepik.com/free-photo/male-asian-engineer-professional-having-discussion-standing-by-machine-factory-two-asian-coworker-brainstorm-explaining-solves-process-curcuit-mother-board-machine_609648-898.jpg?uid=R57968291&ga=GA1.1.1137758464.1733557650&semt=ais_hybrid",
      
    ],
    date: "2024-02-15",
  },
  {
    id: 2,
    title: "Restaurant Interior Renovation",
    category: "Ongoing",
    description: "Complete interior renovation for a specialty restaurant group.",
    thumbnail: "https://img.freepik.com/free-photo/engineer-meeting-architectural-project-working-with-partner_1421-70.jpg",
    images: [
      "/images/projects/restaurant-1.jpg",
      "/images/projects/restaurant-2.jpg",
      "/images/projects/restaurant-3.jpg",
    ],
    date: "2024-03-10",
  },
  {
    id: 3,
    title: "Luxury Hotel Lobby Redesign",
    category: "Ongoing",
    description: "High-end luxury hotel lobby transformation with modern aesthetics.",
    thumbnail: "https://img.freepik.com/free-photo/engineer-meeting-architectural-project-working-with-partner_1421-70.jpg",
    images: [
      "/images/projects/hotel-lobby-1.jpg",
      "/images/projects/hotel-lobby-2.jpg",
      "/images/projects/hotel-lobby-3.jpg",
    ],
    date: "2024-01-20",
  },
  {
    id: 4,
    title: "Urban Cafe Concept",
    category: "Ongoing",
    description: "A stylish urban cafe concept for a trendy coffee chain.",
    thumbnail: "https://img.freepik.com/free-photo/high-angle-measuring-tools-still-life_23-2150440970.jpg?t=st=1741547632~exp=1741551232~hmac=550acec3018dbdd5d25628845ce114e3ccfd773ca687f19f71a0b921af9cbd4f&w=740",
    images: [
      "/images/projects/cafe-1.jpg",
      "/images/projects/cafe-2.jpg",
      "/images/projects/cafe-3.jpg",
    ],
    date: "2024-04-05",
  },
  {
    id: 5,
    title: "Retail Showroom Upgrade",
    category: "Completed",
    description: "A modernized retail showroom with enhanced aesthetics and layout.",
    thumbnail: "https://img.freepik.com/free-photo/man-architect-working-project-with-vr-glasses-new-technologies-3d_1268-29304.jpg?uid=R57968291&ga=GA1.1.1137758464.1733557650&semt=ais_hybridhttps://img.freepik.com/free-photo/man-architect-working-project-with-vr-glasses-new-technologies-3d_1268-29304.jpg?uid=R57968291&ga=GA1.1.1137758464.1733557650&semt=ais_hybrid",
    images: [
      "/images/projects/retail-1.jpg",
      "/images/projects/retail-2.jpg",
      "/images/projects/retail-3.jpg",
    ],
    date: "2023-11-12",
  },
  {
    id: 6,
    title: "Corporate Office Redesign",
    category: "Completed",
    description: "A complete redesign of a corporate workspace with smart technology.",
    thumbnail: "https://img.freepik.com/premium-photo/two-colleagues-discussing-data-working-tablet-laptop-with-architectural-project-construction-site-desk-office_265022-9803.jpg?uid=R57968291&ga=GA1.1.1137758464.1733557650&semt=ais_hybrid",
    images: [
      "/images/projects/office-1.jpg",
      "/images/projects/office-2.jpg",
      "/images/projects/office-3.jpg",
    ],
    date: "2023-12-18",
  },
  {
    id: 7,
    title: "High-End Boutique Interior",
    category: "Completed",
    description: "A luxury boutique with custom interior design elements.",
    thumbnail: "https://img.freepik.com/premium-photo/two-colleagues-discussing-data-working-tablet-laptop-with-architectural-project-construction-site-desk-office_265022-9803.jpg?uid=R57968291&ga=GA1.1.1137758464.1733557650&semt=ais_hybrid",
    images: [
      "/images/projects/boutique-1.jpg",
      "/images/projects/boutique-2.jpg",
      "/images/projects/boutique-3.jpg",
    ],
    date: "2023-09-22",
  },
  {
    id: 8,
    title: "Modern Co-Working Space",
    category: "Completed",
    description: "A dynamic co-working space designed for startups and freelancers.",
    thumbnail: "https://img.freepik.com/premium-photo/two-colleagues-discussing-data-working-tablet-laptop-with-architectural-project-construction-site-desk-office_265022-9803.jpg?uid=R57968291&ga=GA1.1.1137758464.1733557650&semt=ais_hybrid",
    images: [
      "/images/projects/coworking-1.jpg",
      "/images/projects/coworking-2.jpg",
      "/images/projects/coworking-3.jpg",
    ],
    date: "2023-10-05",
  },
  {
    id: 9,
    title: "Luxury Spa & Wellness Center",
    category: "Completed",
    description: "A high-end spa with a tranquil and refreshing environment.",
    thumbnail: "https://img.freepik.com/premium-photo/mechanized-industry-robot-arm-factory-worker-double-exposure_31965-16584.jpg?uid=R57968291&ga=GA1.1.1137758464.1733557650&semt=ais_hybrid",
    images: [
      "/images/projects/spa-1.jpg",
      "/images/projects/spa-2.jpg",
      "/images/projects/spa-3.jpg",
    ],
    date: "2023-07-30",
  },
  {
    id: 10,
    title: "Smart Home Automation",
    category: "Ongoing",
    description: "A futuristic smart home project integrating AI and IoT.",
    thumbnail: "https://img.freepik.com/free-photo/male-asian-engineer-professional-having-discussion-standing-by-machine-factory-two-asian-coworker-brainstorm-explaining-solves-process-curcuit-mother-board-machine_609648-898.jpg?uid=R57968291&ga=GA1.1.1137758464.1733557650&semt=ais_hybrid",
    images: [
      "/images/projects/smart-home-1.jpg",
      "/images/projects/smart-home-2.jpg",
      "/images/projects/smart-home-3.jpg",
    ],
    date: "2024-05-10",
  },
  {
    id: 11,
    title: "Sustainable Office Building",
    category: "Ongoing",
    description: "An eco-friendly office space with solar energy integration.",
    thumbnail: "https://img.freepik.com/free-photo/male-asian-engineer-professional-having-discussion-standing-by-machine-factory-two-asian-coworker-brainstorm-explaining-solves-process-curcuit-mother-board-machine_609648-898.jpg?uid=R57968291&ga=GA1.1.1137758464.1733557650&semt=ais_hybrid",
    images: [
      "/images/projects/sustainable-1.jpg",
      "/images/projects/sustainable-2.jpg",
      "/images/projects/sustainable-3.jpg",
    ],
    date: "2024-06-01",
  },
  {
    id: 12,
    title: "Fine Dining Restaurant Design",
    category: "Completed",
    description: "A world-class fine dining restaurant with a luxurious ambiance.",
    thumbnail: "https://img.freepik.com/free-photo/male-asian-engineer-professional-having-discussion-standing-by-machine-factory-two-asian-coworker-brainstorm-explaining-solves-process-curcuit-mother-board-machine_609648-898.jpg?uid=R57968291&ga=GA1.1.1137758464.1733557650&semt=ais_hybrid",
    images: [
      "/images/projects/fine-dining-1.jpg",
      "/images/projects/fine-dining-2.jpg",
      "/images/projects/fine-dining-3.jpg",
    ],
    date: "2023-08-14",
  },
];







// -------------------------------------------- solutions Data Array --------------------------------------------

export const solutionsData = [
  {
      title: "ELECTRICAL ( Supply, Installation, Testing & Commissioning )",
      image: "/images/imge2.jpeg",
      points: [
          {
              header: "Power Distribution & Lighting",
              items: [
                  "Interior Electrification involving Distribution Boards.",
                  "Internal & External Power Distribution, Emergency Lighting & Power Back-up System (Transformers, DG Sets, UPS).",
                  "Street lighting, Façade and Landscape lighting.",
              ],
          },
          {
              header: "Building & Utility Systems",
              items: [
                  "Fire Protection, Public Address Systems, Earthing and Lightning Protection System.",
                  "Building Management System and Data Centers.",
                  "HT switchboard works.",
              ],
          },
      ],
  },
  {
      title: "FIRE SAFETY & IBMS ( Supply Installation, Testing & Commissioning )",
      image: "/images/imge2.jpeg",
      points: [
          {
              header: "Fire Protection Systems",
              items: [
                  "Fire Detection & Public Address System.",
                  "Fire Suppression System – Gas-based system.",
              ],
          },
          {
              header: "Security & Management",
              items: [
                  "ELV Systems and Security Solutions.",
                  "CCTV and Access Control.",
                  "Building management system.",
              ],
          },
      ],
  },
  {
      title: "MECHANICAL – HVAC ( Supply, Installation, Testing & Commissioning )",
      image: "/images/imge4.jpeg",
      points: [
          {
              header: "HIGH SIDE",
              items: [
                  "HVAC Systems, Cooling towers, and Air Handling Units.",
              ],
          },
          {
              header: "LOW SIDE",
              items: [
                  "Air distribution systems, Ducting and Accessories.",
                  "Chilled and Condensed Water Chemical Treatment.",
              ],
          },
      ],
  },
];


// ------------------------------------------ about as page Arrys ----------------------------------------------------

export const benefitsData = [
  { title: "Electrical fit-out and HT/LT works", description: "Currently we are operating Electrical installations work within the Karnataka state and we are looking forward to extend our hands in other state soon.", link: "/" },
  { title: "Mechanical-Heating/ Ventilation/ Air Conditioning", description: "Thermal comfort and acceptable indoor air quality are key to modern commercial, industrial and residential buildings. We offer wide range of solutions that address customized Heating, Ventilation and Air Conditioning needs of our customers.", link: "/" },
  { title: "Plumbing -Water Distribution Installation", description: "Efficient water supply plays a critical role in modern buildings. We offer professional plumbing installation and maintenance services.", link: "/" },
  { title: "Fire Safety and Protection Solutions", description: "Incidence of fire can cause major damages to infrastructures and may prove fatal at times . It is important to secure ones infrastructure from Fire. To help our customers protect their people and precious infrastructure, we offer holistic Fire Safety & Risk Management services.", link: "/" },
];

export const teamData = [
  { name: "Theresa Webb", role: "Developer", image: "https://img.freepik.com/free-photo/young-bearded-man-with-striped-shirt_273609-5677.jpg?uid=R57968291&ga=GA1.1.1137758464.1733557650&semt=ais_hybrid", social: { facebook: "#", twitter: "#", linkedin: "#" } },
  { name: "Courtney Henry", role: "UI/UX Designer", image: "https://img.freepik.com/free-photo/young-bearded-man-with-striped-shirt_273609-5677.jpg?uid=R57968291&ga=GA1.1.1137758464.1733557650&semt=ais_hybrid", social: { facebook: "#", twitter: "#", linkedin: "#" } },
  { name: "Courtney Henry", role: "UI/UX Designer", image: "https://img.freepik.com/free-photo/young-bearded-man-with-striped-shirt_273609-5677.jpg?uid=R57968291&ga=GA1.1.1137758464.1733557650&semt=ais_hybrid", social: { facebook: "#", twitter: "#", linkedin: "#" } },
  { name: "Courtney Henry", role: "UI/UX Designer", image: "https://img.freepik.com/free-photo/young-bearded-man-with-striped-shirt_273609-5677.jpg?uid=R57968291&ga=GA1.1.1137758464.1733557650&semt=ais_hybrid", social: { facebook: "#", twitter: "#", linkedin: "#" } },

];
